export enum SalesChannelType {
  URMART = 1,
  STORE_DIRECT = 2,
  STORE_FRANCHISE = 3,
  OTHER = 4,
}

export default SalesChannelType;
